import React from "react";
import "./App.css";
import ApplicationRoutes from "./config/ApplicationRoutes";
import "rsuite/dist/styles/rsuite-default.css";
import "./css/App.css";

function App() {
  return <ApplicationRoutes />;
}

export default App;
